import React, { useState, useEffect } from "react";
import { Routes, Route, useNavigate, Link } from "react-router-dom";
import routes from "routes.js";
// Chakra imports
import {
  Avatar,
  Box,
  Stack,
  Text,
  Flex,
  useColorMode,
  useColorModeValue,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  MenuDivider,
  MenuGroup,
  Portal,
} from "@chakra-ui/react";
// Custom Components
import { ItemContent } from "components/Menu/ItemContent";
// icons
import { SettingsIcon } from "components/Icons/Icons";
import { FaSun } from "react-icons/fa6";
import { IoMoon } from "react-icons/io5";
import { BellIcon } from "@chakra-ui/icons";
// Assets
import avatar1 from "assets/img/avatars/Lex.png";
import DAlogo60 from "assets/img/logos/DALogo60x60.png";
import { SupportTextLight } from "components/Icons/Icons";
import { color } from "framer-motion";
import useAxiosPrivate from "hooks/useAxiosPrivate";
import { getUser } from "api/requests/getUser";
import useLogout from "hooks/useLogout";

const Landing = () => {
  const { colorMode, toggleColorMode } = useColorMode();
  const navigate = useNavigate();
  const axiosPrivate = useAxiosPrivate();
  const [user, setUser] = useState();
  const storedUser = localStorage.getItem("user");
  const username = storedUser ? storedUser : "Sign In";
  const logout = useLogout();
  useEffect(() => {
    getUser(axiosPrivate).then((user) => setUser(user));
  }, []);

  const signOut = async () => {
    await logout();
  };

  let iconColor = useColorModeValue("yellow", "orange");
  let navbarIcon = useColorModeValue("white", "gray.200");
  let menuBg = useColorModeValue("white", "#343A40");
  let textColor = useColorModeValue("white", "gray.700");

  return (
    <Flex justify={"space-between"}>
      <Stack direction="row" spacing="12px" align="center" p={5}>
        <Avatar src={DAlogo60} borderRadius="8px" w="60px" h="60px" me="14px" />
        <Box w="1px" h="30px" bg={"black"} />
        <SupportTextLight w="87px" h="20px" />
        <Box px={3} />
        <Text as={Link} to="/landing/knowledgebase" color={"white"}>
          Home
        </Text>
        <Box px={3} />
        <Text as={Link} to="https://dealeralchemist.com" color={"white"}>
          Website
        </Text>
        <Box px={3} />
        <Text as={Link} to="/admin/dashboard" color={"white"}>
          Dasboard
        </Text>
      </Stack>
      <Stack direction="row" spacing="12px" align="center" p={5}>
        <Menu me={{ sm: "2px", md: "16px" }}>
          <MenuButton
            px={4}
            py={1}
            mr={4}
            transition={"all 0.2s"}
            borderRadius={"md"}
            color={navbarIcon}
            _hover={{ bg: "blue.400" }}
            _expanded={{ bg: "blue.400" }}
            _focus={{ boxShadow: "outline" }}
          >
            <Flex align={"center"}>
              <Avatar
                src={user?.image}
                border={"1px"}
                bg={"blue.300"}
                size={"sm"}
                mr={3}
              />
              <Text>{user?.username}</Text>
            </Flex>
          </MenuButton>
          <Portal>
            <MenuList zIndex="9997">
              <MenuGroup title="Profile">
                <MenuItem
                  onClick={() =>
                    navigate("/admin/my-account/", { replace: true })
                  }
                >
                  My Account
                </MenuItem>
                <MenuItem onClick={signOut} _hover={{ bg: "red.500" }}>
                  Logout{" "}
                </MenuItem>
              </MenuGroup>
              <MenuDivider />
              <MenuGroup title="Help">
                <MenuItem
                  onClick={() =>
                    navigate("/landing/knowledgebase", { replace: true })
                  }
                >
                  Knowledge Base
                </MenuItem>
                <MenuItem>FAQ</MenuItem>
              </MenuGroup>
            </MenuList>
          </Portal>
        </Menu>
        {colorMode === "dark" ? (
          <FaSun
            cursor="pointer"
            ms={{ base: "16px", xl: "0px" }}
            me="16px"
            onClick={toggleColorMode}
            color={iconColor}
            size="20px"
          />
        ) : (
          <IoMoon
            cursor="pointer"
            ms={{ base: "16px", xl: "0px" }}
            me="16px"
            onClick={toggleColorMode}
            color={iconColor}
            size="20px"
          />
        )}
        <SettingsIcon
          cursor="pointer"
          ms={{ base: "16px", xl: "22px" }}
          me="16px"
          color={navbarIcon}
          w="24px"
          h="24px"
        />
        <Menu>
          <MenuButton>
            <BellIcon color={navbarIcon} w="24px" h="24px" />
          </MenuButton>
          <Portal>
            <MenuList p="16px 8px" bg={menuBg} zIndex="9998">
              <Flex flexDirection="column">
                <MenuItem borderRadius="md" mb="10px">
                  <ItemContent
                    time="13 minutes ago"
                    info="by Lex"
                    boldInfo="New Client Added"
                    aName="Lex"
                    aSrc={avatar1}
                  />
                </MenuItem>
                <MenuItem borderRadius="md" mb="10px">
                  <ItemContent
                    time="2 days ago"
                    info="by Lex"
                    boldInfo="New User PickleRick Added"
                    aName="Lex"
                    aSrc={avatar1}
                  />
                </MenuItem>
                <MenuItem borderRadius="md">
                  <ItemContent
                    time="3 days ago"
                    info="by Lex"
                    boldInfo="New EBlast completed"
                    aName="Lex"
                    aSrc={avatar1}
                  />
                </MenuItem>
              </Flex>
            </MenuList>
          </Portal>
        </Menu>
      </Stack>
    </Flex>
  );
};

export default Landing;
